import { ContainerBloco, TituloBloco, LinhaQuebradaInfo } from "../../../Common/styles";
import { IProposta } from "../../../../../utility/IProposta";
import { comum } from "../../../../../styles/Themes/light";
import { IconClock } from "../../../../icons";
import { FlexCronograma, SpanHoraBrasilia, DataWrapper } from "./styles";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DateTimePickerEditavel from "../../../../form/DateTimePickerEditavel";

interface BlocoCronogramaProps {
    demanda?: IProposta | null;
    loading?: boolean;
    isEditing?: boolean;
    isDisabled?: boolean;
    isDisabledPrazoAceite?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
}

export default function BlocoCronograma({demanda, loading = false, isEditing = false, isDisabled = false, isDisabledPrazoAceite = false, onChange, onBlur, errors}: BlocoCronogramaProps) {

    const formattedDateTime = (data: string | null | undefined) => {
        if (!data) return 'N/A';
        const date = new Date(data);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} - ${hours}:${minutes}`;
    };

    const brasiliaDateTime = (data: string | null | undefined) => {
        if (!data || !demanda?.data_tz) return 'N/A';
        
        const originalDate = new Date(data);
        let brasiliaDate = new Date(originalDate);
        
        const timezoneOffsets = {
            'BRT': 0,    // Already in BRT
            'AMT': 1,    // AMT is UTC-4, BRT is UTC-3, so add 1 hour
            'ACT': 2,    // ACT is UTC-5, BRT is UTC-3, so add 2 hours
            'FNT': -1    // FNT is UTC-2, BRT is UTC-3, so subtract 1 hour
        };
        
        const offset = timezoneOffsets[demanda.data_tz as keyof typeof timezoneOffsets] || 0;
        brasiliaDate.setHours(brasiliaDate.getHours() + offset);
        return formattedDateTime(brasiliaDate.toISOString());
    };

    const brasiliaDateTimeCriado = (data: string | null | undefined, timezone: string | null | undefined) => {
        if (!data || !timezone) return 'N/A';
        
        const originalDate = new Date(data);
        let brasiliaDate = new Date(originalDate);
        
        const timezoneOffsets = {
            'BRT': 0,    // Already in BRT
            'AMT': 1,    // AMT is UTC-4, BRT is UTC-3, so add 1 hour
            'ACT': 2,    // ACT is UTC-5, BRT is UTC-3, so add 2 hours
            'FNT': -1    // FNT is UTC-2, BRT is UTC-3, so subtract 1 hour
        };
        
        const offset = timezoneOffsets[timezone as keyof typeof timezoneOffsets] || 0;
        brasiliaDate.setHours(brasiliaDate.getHours() + offset);
        return formattedDateTime(brasiliaDate.toISOString());
    };

    const handleDateChange = (campo: string, value: string) => {
        if (onChange) {
            onChange(campo, value);
        }
    };

    return (
        <ContainerBloco>
            {loading ? (
                <>
                    <Skeleton height={24} width="50%" style={{ marginBottom: '12px' }} />
                    <FlexCronograma>   
                        <Skeleton height={80} width="100%" style={{ marginBottom: '12px' }} />
                        <Skeleton height={80} width="100%" style={{ marginBottom: '12px' }} />
                        <Skeleton height={80} width="100%" style={{ marginBottom: '12px' }} />
                        <Skeleton height={80} width="100%" />
                    </FlexCronograma>
                </>
            ) : (
                <>
                <TituloBloco>
                    <IconClock size={16} color={comum.colors.primaryRed400}/>
                    Cronograma
                </TituloBloco>
                <FlexCronograma>   
                    <LinhaQuebradaInfo>
                        <span className="label">Solicitada em</span>
                        <DataWrapper>
                            <DateTimePickerEditavel
                                value={demanda?.criado}
                                onChange={(value) => handleDateChange('criado', value)}
                                isEditing={isEditing}
                                disabled={true}
                                timezone={demanda?.criado_tz || demanda?.data_tz}
                            />
                            {!isEditing && demanda?.criado && (demanda?.criado_tz || demanda?.data_tz) && (demanda?.criado_tz || demanda?.data_tz) !== 'BRT' && (
                                <SpanHoraBrasilia>  
                                    Brasília: {brasiliaDateTimeCriado(demanda?.criado, demanda?.criado_tz || demanda?.data_tz)} (BRT)
                                </SpanHoraBrasilia>
                            )}
                        </DataWrapper>
                    </LinhaQuebradaInfo>
                    <LinhaQuebradaInfo>
                        <span className="label">Prazo para aceite</span>
                        <DataWrapper>
                            <DateTimePickerEditavel
                                value={demanda?.prazo_aceite}
                                onChange={(value) => handleDateChange('prazo_aceite', value)}
                                onBlur={() => onBlur && onBlur('prazo_aceite')}
                                isEditing={isEditing}
                                disabled={isDisabledPrazoAceite}
                                timezone={demanda?.data_tz}
                                error={errors?.prazo_aceite}
                            />
                            {!isEditing && demanda?.prazo_aceite && demanda?.data_tz && demanda?.data_tz !== 'BRT' && (
                                <SpanHoraBrasilia>  
                                    Brasília: {brasiliaDateTime(demanda?.prazo_aceite)} (BRT)
                                </SpanHoraBrasilia>
                            )}
                        </DataWrapper>
                    </LinhaQuebradaInfo>
                    <LinhaQuebradaInfo>
                        <span className="label">Iniciada em</span>
                        <DataWrapper>
                            <DateTimePickerEditavel
                                value={demanda?.data_inicio}
                                onChange={() => {}}
                                isEditing={isEditing}
                                disabled={true}
                                timezone={demanda?.data_inicio && demanda?.data_tz ? demanda.data_tz : undefined}
                            />
                            {!isEditing && demanda?.data_inicio && demanda?.data_tz && demanda?.data_tz !== 'BRT' && (
                                <SpanHoraBrasilia>  
                                    Brasília: {brasiliaDateTime(demanda?.data_inicio)} (BRT)
                                </SpanHoraBrasilia>
                            )}
                        </DataWrapper>
                    </LinhaQuebradaInfo>
                    <LinhaQuebradaInfo>
                        <span className="label">Prazo para conclusão</span>
                        <DataWrapper>
                            <DateTimePickerEditavel
                                value={demanda?.prazo_para_conclusao}
                                onChange={(value) => handleDateChange('prazo_para_conclusao', value)}
                                onBlur={() => onBlur && onBlur('prazo_para_conclusao')}
                                isEditing={isEditing}
                                disabled={isDisabled}
                                timezone={demanda?.data_tz}
                                error={errors?.prazo_para_conclusao}
                            />
                            {!isEditing && demanda?.prazo_para_conclusao && demanda?.data_tz && demanda?.data_tz !== 'BRT' && (
                                <SpanHoraBrasilia>  
                                    Brasília: {brasiliaDateTime(demanda?.prazo_para_conclusao)} (BRT)
                                </SpanHoraBrasilia>
                            )}
                        </DataWrapper>
                    </LinhaQuebradaInfo>
                </FlexCronograma>
                </>
            )}
        </ContainerBloco>
    )
}

